const en = {
  zoomTitle: 'Zoom In',
  pinTitle: 'Pin',
  unpinTitle: 'Unpin',
  scrollToImageTitle: 'Scroll To Image',
  newWindowTitle: 'Open In New Tab',
};

export default en;
